import { createFileRoute } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { EmployeeFormPage } from 'src/modules/automations/components/pages/employees/employee-form.page';
import {
  employeePathSchema,
  employeeSearchSchema,
} from 'src/modules/automations/schemas/employees/employees.schema';

export const Route = createFileRoute('/employees/$employeeId/')({
  component: EmployeeDetailComponent,
  validateSearch: (search) => employeeSearchSchema.parse(search),
  params: {
    parse: (params) => employeePathSchema.parse(params),
  },
});

function EmployeeDetailComponent() {
  const { employeeId } = Route.useParams();

  return (
    <AuthenticateRoute>
      <EmployeeFormPage employeeId={employeeId} isEdit={true} />
    </AuthenticateRoute>
  );
}
